<template>
  <section-content :title="i18n.t('/Correcties/AddCorrectieModal/Title')">
    <correction-items
      :discounts="discounts"
      :label-prefix="labelPrefix"
      @toggle-discount="toggleDiscount($event)"
      @update-discount-amount="updateDiscountAmount"
    ></correction-items>
  </section-content>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import StoreConnector from '@/helpers/StoreConnector'
import constants from '@/utils/constants'

import discountType from '@/helpers/enums/discountType'

import SectionContent from '@/components/generic/presentational/atoms/sectionContent/SectionContent.vue'
import CorrectionItems from '@/components/generic/presentational/molecules/addCorrection/CorrectionItems.vue'

export default {
  components: {
    SectionContent,
    CorrectionItems,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      totalPrice: 0,
      configurationNetCatalogPrice: 0,
      configurationPrice: 0,
      customCorrectionProduct: null,
      correctionCategoryCode: constants.CORRECTION_CATEGORY_CODE,
      discounts: [
        {
          id: 'discountAbsExcl',
          type: discountType.absolute,
          selected: false,
          amount: 0,
        },
        {
          id: 'discountAbsIncl',
          type: discountType.absolute,
          selected: false,
          amount: 0,
        },
        {
          id: 'discountPercExcl',
          type: discountType.percentage,
          selected: false,
          amount: 0,
        },
        {
          id: 'discountPercIncl',
          type: discountType.percentage,
          selected: false,
          amount: 0,
        },
      ],
      labelPrefix: '/Correcties/AddCorrectieModal',
    }
  },
  computed: {
    errorMessage() {
      return this.v$.name.$anyDirty && !this.v$.name.required.$response ? 'error' : ''
    },
    selectedDiscount() {
      return this.discounts.find((a) => a.selected)
    },
  },
  created() {
    StoreConnector.get('quote/totalPrice', (data) => {
      this.totalPrice = data
    })

    StoreConnector.get('configuration/netCatalogPrice', (data) => {
      this.configurationNetCatalogPrice = data
    })

    StoreConnector.get('configuration/price', (data) => {
      this.configurationPrice = data
    })

    StoreConnector.getWithParam(
      'quote/customCorrectionProduct',
      this.correctionCategoryCode,
      (data) => {
        this.customCorrectionProduct = data
      }
    )
  },
  methods: {
    toggleDiscount(index) {
      if (this.discounts[index].selected) {
        this.discounts[index].selected = false
        return
      }

      this.discounts.forEach((discount) => {
        discount.selected = false
      })

      this.discounts[index].selected = true

      this.$nextTick(() => {
        document.getElementById(this.discounts[index].id).focus()
        document.getElementById(this.discounts[index].id).select()
      })
    },
    updateDiscountAmount(amount) {
      this.selectedDiscount.amount = amount
      let price = 0

      if (this.selectedDiscount.id === 'discountAbsExcl') {
        price = amount * 1.21
      } else if (this.selectedDiscount.id === 'discountAbsIncl') {
        price = amount
      } else if (this.selectedDiscount.id === 'discountPercIncl') {
        price = (this.configurationPrice.Excl / 100) * amount * 1.21
      } else if (this.selectedDiscount.id === 'discountPercExcl') {
        price = (this.configurationNetCatalogPrice.Excl / 100) * amount * 1.21
      } else {
        return
      }
      this.addDiscountToQuote(price)
    },
    addDiscountToQuote(price) {
      const product = {
        Name: this.selectedDiscount.title,
        Price: {
          Incl: price * -1,
        },
        Standard: false,
        Category: 'Corrections',
        AnalysisCode: this.correctionCategoryCode,
      }

      if (this.customCorrectionProduct != null) {
        StoreConnector.dispatch('quote/removeFromAccessories', this.customCorrectionProduct)
      }

      StoreConnector.dispatch('quote/addToAccessories', product)
    },
  },
}
</script>

<style lang="scss" scoped></style>
